"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRootPageState = void 0;
var Translate_init_1 = require("@/pages/common/states/Translate.init");
var Pages_1 = require("@/rendering/common/Pages");
var UserState_init_1 = require("@/pages/common/states/UserState.init");
var LayoutState_init_1 = require("@/pages/common/states/LayoutState.init");
var DrelateState_init_1 = require("@/pages/common/states/DrelateState.init");
var DfootState_init_1 = require("@/pages/common/states/DfootState.init");
var MessageState_init_1 = require("@/pages/common/states/MessageState.init");
var BigPopup_init_1 = require("@/pages/common/states/BigPopup.init");
var CallOrEmailState_init_1 = require("@/pages/common/states/CallOrEmailState.init");
var ServerSideSchemaState_init_1 = require("@/pages/common/states/schema/ServerSideSchemaState.init");
var ShareState_init_1 = require("@/pages/common/states/ShareState.init");
var httpResponse_1 = require("@/utils/httpResponse");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
var SavePropertyRemoteState_init_1 = require("@/pages/common/states/SavePropertyRemoteState.init");
exports.defaultRootPageState = {
    translate: Translate_init_1.defaultTranslate,
    resultT: ResultPageState_init_1.defaultResultPageState.t,
    page: Pages_1.Pages.SEARCH,
    user: UserState_init_1.defaultUserstate,
    layout: LayoutState_init_1.defaultLayoutState,
    drelate: DrelateState_init_1.defaultDrelateState,
    dfoot: DfootState_init_1.defaultDfootState,
    message: MessageState_init_1.defaultMessageState,
    bigpopup: BigPopup_init_1.defaultBigPopupState,
    callOrEmail: CallOrEmailState_init_1.defaultCallOrEmailState,
    serverSideSchema: ServerSideSchemaState_init_1.defaultServerSideSchemaState,
    analyticActions: httpResponse_1.defaultExternalProvidersPascal,
    savePropertyRemote: SavePropertyRemoteState_init_1.defaultSavePropertyRemoteState,
    share: ShareState_init_1.defaultShareState,
    csrfToken: '',
    mobile: false
};
